export default __webpack_public_path__ + "assets/static/media/seeking.8196bd9b.svg";